/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAdministrativesRequestPayload } from '../../models/get-administratives-request-payload';
import { GetAdministrativesResponse } from '../../models/get-administratives-response';

export interface PostAdministrativeV1CompaniesWithoutBreakVisibility$Plain$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: GetAdministrativesRequestPayload
}

export function postAdministrativeV1CompaniesWithoutBreakVisibility$Plain(http: HttpClient, rootUrl: string, params?: PostAdministrativeV1CompaniesWithoutBreakVisibility$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAdministrativesResponse>> {
  const rb = new RequestBuilder(rootUrl, postAdministrativeV1CompaniesWithoutBreakVisibility$Plain.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAdministrativesResponse>;
    })
  );
}

postAdministrativeV1CompaniesWithoutBreakVisibility$Plain.PATH = '/private/v1/companies/without-break-visibility';
